import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppStiRanking } from '../models/mobileAppStiRanking';

@Component({
  template: `
    <img
      src="https://cdn.pixalate.com/sellers/icons/apn/16x16/{{
        data?.sellerId
      }}.jpg?cb"
      alt="{{ data?.sellerName }} Icon"
      onerror="this.src='/assets/icons/icon-72x72-grey.png'"
      class="mr-2 rounded"
      width="32"
    />
    <div class="overflow-hidden" style="display: inline;">
      {{ data?.sellerName }}
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellerNameComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppStiRanking;

  ngOnInit() {
    super.ngOnInit();
  }
}
